import { render, staticRenderFns } from "./IndividualContact2.vue?vue&type=template&id=3a3a5e8a&scoped=true&"
import script from "./IndividualContact2.vue?vue&type=script&lang=js&"
export * from "./IndividualContact2.vue?vue&type=script&lang=js&"
import style0 from "./IndividualContact2.vue?vue&type=style&index=0&id=3a3a5e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3a5e8a",
  null
  
)

export default component.exports